import api from './api';

export const getUserGroups = (params) => api.get('/v1/user-groups', { params });
export const getUserGroup = (id) => api.get(`/v1/user-groups/${id}`);
export const createUserGroup = (data) => api.post('/v1/user-groups', data);
export const updateUserGroup = (id, data) => api.put(`/v1/user-groups/${id}`, data);
export const deleteUserGroup = (id) => api.delete(`/v1/user-groups/${id}`);
export const getUserGroupUsers = (id) => api.get(`/v1/user-groups/${id}/users`);
export const addUserGroupUser = (id, data) => api.post(`/v1/user-groups/${id}/users`, data);
export const removeUserGroupUser = (id, userId) => api.delete(`/v1/user-groups/${id}/users/${userId}`);

// Dinamik grup kriter kurucusunun uyruk açılır listesi: kiracıda FİİLEN var olan
// değerler. Serbest metin yazdırmak Türkçe i/İ tuzağı ve tipo yüzünden sessizce
// eşleşmeyen kriter üretirdi.
export const getUserGroupNationalities = () => api.get('/v1/user-groups/nationalities');
